/**
 * Created by slava on 24.03.17.
 */

const SelectFriendWindow = CleverappsWindow.extend({
    onWindowLoaded: function (type, onFriendsSelected, callback) {
        this.callback = callback;
        const content = new cc.Node();
        content.setAnchorPoint(0.5, 0.5);
        this.content = content;
        this.type = type;

        if (cleverapps.config.debugMode) {
            SelectFriendWindow.PROCESS_PERIOD = "300 second";
        }

        const allFriends = cleverapps.friends.listFriends();

        if (!allFriends.length) {
            this.generateNoFriendsContent();
        } else {
            this.generateFriendsContent(allFriends, onFriendsSelected);
        }

        this._super({
            title: Messages.get(SelectFriendWindow.ByType[this.type].title),
            name: `selectfriendwindow${type}`,
            content,
            styles: cleverapps.styles.SelectFriendWindow.window
        });
    },

    addCheck: function (container, disabled) {
        const check = new cc.Sprite(bundles.checkbox.frames.check_mark_png);
        if (disabled) {
            cleverapps.UI.convertToGrayScale(check);
        }
        check.setPosition(container.width / 2, container.height / 2);
        container.check = check;
        container.addChild(check);
    },

    checkElementByFriendId: function (friendId, container) {
        const uid = this.selectedElements.friends.indexOf(friendId);

        if (uid !== -1) {
            this.selectedElements.data[friendId].checked = false;
            this.selectedElements.data[friendId].check.removeFromParent();
            this.selectedElements.data[friendId] = undefined;
            this.selectedElements.friends.splice(uid, 1);
        } else {
            this.addCheck(container);
            container.checked = true;
            this.selectedElements.data[friendId] = container;
            this.selectedElements.friends.push(friendId);
            if (this.selectedElements.friends.length > SelectFriendWindow.MAX_SELECTED) {
                this.checkElementByFriendId(this.selectedElements.friends[0]);
            }
        }
        this.updateSelectedContent();
    },

    generateCheckbox: function (friend, container) {
        const styles = cleverapps.styles.SelectFriendWindow.withFriends.friendContainer.checkBox;

        if (!this.processTimeData) {
            this.processTimeData = cleverapps.dataLoader.load(SelectFriendWindow.ByType[this.type].dataLoaderType());
            if (!this.processTimeData) {
                this.processTimeData = {};
            }
            for (const id in this.processTimeData) {
                if (this.processTimeData[id] < Date.now() - cleverapps.parseInterval(SelectFriendWindow.PROCESS_PERIOD)) {
                    this.processTimeData[id] = undefined;
                }
            }
        }

        const applyClick = function () {
            cleverapps.UI.onClick(container, () => {
                this.checkElementByFriendId(friend.id, checkBoxBg);
            }, {
                interactiveScale: false
            });

            cleverapps.UI.applyHover(container, {
                onMouseOver: function () {
                    if (container.bg) {
                        container.bg.setColor(cleverapps.styles.COLORS.HOVER);
                    }
                    checkBoxBg.setScale(1.1);
                },
                onMouseOut: function () {
                    if (container.bg) {
                        container.bg.setColor(cleverapps.styles.COLORS.WHITE);
                    }
                    checkBoxBg.setScale(1);
                }
            });
        }.bind(this);

        const checkBoxBg = this.generateCheckBoxBg();
        checkBoxBg.setAlignment(styles.x, container.height / 2 + cleverapps.styles.SelectFriendWindow.Avatar.y);

        container.fullData = {
            checkBox: checkBoxBg,
            id: friend.id
        };

        container.addChild(checkBoxBg);

        if (this.processTimeData) {
            if (this.processTimeData[friend.id] && this.processTimeData[friend.id] > Date.now() - cleverapps.parseInterval(SelectFriendWindow.PROCESS_PERIOD)) {
                const timerViewParams = {
                    showHours: true,
                    font: cleverapps.styles.FONTS.WINDOW_SMALL_TEXT,
                    imageFont: false
                };
                console.log("disabled", container);
                const timeLeft = this.processTimeData[friend.id] + cleverapps.parseInterval(SelectFriendWindow.PROCESS_PERIOD) - Date.now();
                const timer = new cleverapps.CountDownView(new cleverapps.CountDown(timeLeft), timerViewParams);
                const onFinish = function () {
                    timer.refresh();
                    timer.removeFromParent();
                    container.name.setVisible(true);
                    container.avatar.setOpacity(255);
                    checkBoxBg.setOpacity(255);
                    if (container.coinsIcon) {
                        container.coinsIcon.setOpacity(255);
                    }
                    checkBoxBg.check.removeFromParent();
                    container.notActive = false;
                    applyClick();
                };
                timer.onEnter = function () {
                    cleverapps.CountDownView.prototype.onEnter.call(this);
                    timer.countDown.onFinish = timer.createListener(onFinish);
                };

                timer.setPosition(container.width / 2, styles.timer.y);
                container.addChild(timer);
                container.name.setVisible(false);
                this.addCheck(checkBoxBg, true);
                checkBoxBg.setOpacity(150);
                container.avatar.setOpacity(120);
                container.notActive = true;
                if (container.coinsIcon) {
                    container.coinsIcon.setOpacity(150);
                }
                return;
            }
        }

        container.notActive = false;
        applyClick();
    },

    generateCheckBoxBg: function () {
        const checkBoxBg = new cc.Sprite(bundles.checkbox.frames.checkbox_background_png);
        checkBoxBg.setAnchorPoint(0.5, 0.5);
        checkBoxBg.setCascadeOpacityEnabled(true);
        return checkBoxBg;
    },

    generateFriendContent: function (friend) {
        const styles = cleverapps.styles.SelectFriendWindow.withFriends.friendContainer;

        const container = new cc.Node();
        container.setAnchorPoint(0.5, 0.5);
        container.setContentSize(styles.width, styles.height);

        if (bundles.select_friend_window.frames.friend_bg_png) {
            const bg = cleverapps.UI.createScale9Sprite(bundles.select_friend_window.frames.friend_bg_png);
            bg.setAnchorPoint(0.5, 0.5);
            bg.setContentSize(styles.width, styles.height);
            bg.setPosition(container.width / 2, container.height / 2);
            container.addChild(bg);
            container.bg = bg;
        }

        const avatar = new cleverapps.UI.Avatar(friend);
        avatar.setAlignment(cleverapps.styles.SelectFriendWindow.Avatar.x, container.height / 2 + cleverapps.styles.SelectFriendWindow.Avatar.y);
        avatar.setAnchorPoint(0.5, 0.5);
        container.avatar = avatar;
        cleverapps.UI.fitToBox(avatar, { height: cleverapps.styles.SelectFriendWindow.Avatar.height });
        avatar.setCascadeOpacityEnabled(true);
        container.addChild(avatar);

        const friendName = friend.name || (`Player_${friend.id.slice(-3)}`);
        const name = cleverapps.UI.generateOnlyText(friendName, cleverapps.styles.FONTS.WINDOW_SMALL_TEXT);
        name.setDimensions(styles.Name.width, styles.Name.height);
        name.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        name.setVerticalAlignment(cc.VERTICAL_TEXT_ALIGNMENT_TOP);
        container.addChild(name);
        name.setAlignment(container.width / 2, styles.Name.y);
        container.name = name;

        this.generateCheckbox(friend, container);

        return container;
    },

    generateFriendsContent: function (friends, onFriendsSelected) {
        this.selectedElements = {
            friends: [],
            data: {}
        };

        const styles = cleverapps.styles.SelectFriendWindow.withFriends;
        this.content.setContentSize(styles.width, styles.height);

        const button = new cleverapps.UI.Button({
            text: Messages.get(SelectFriendWindow.ByType[this.type].button),
            width: styles.Button.width,
            height: styles.Button.height,
            onClicked: function () {
                this.send = true;

                if (this.selectedElements.friends.length) {
                    if (this.processTimeData) {
                        for (let i = 0; i < this.selectedElements.friends.length; i++) {
                            this.processTimeData[this.selectedElements.friends[i]] = Date.now();
                        }
                        cleverapps.dataLoader.save(SelectFriendWindow.ByType[this.type].dataLoaderType(), this.processTimeData);
                    }

                    this.close();
                    onFriendsSelected(this.selectedElements.friends);
                }
            }.bind(this)
        });
        button.setAlignment(this.content.width / 2 + styles.Button.x, styles.Button.y);
        this.button = button;
        this.content.addChild(button);

        const selectedNode = new cc.Node();
        selectedNode.setAnchorPoint(0, 0.5);
        selectedNode.setAlignment(styles.SelectedBlock.x, styles.SelectedBlock.y);

        const selectedCheckBox = this.generateCheckBoxBg();
        selectedCheckBox.setAnchorPoint(0, 0.5);
        selectedCheckBox.setAlignment(0, selectedCheckBox.height / 2);
        selectedNode.addChild(selectedCheckBox);
        // eslint-disable-next-line no-restricted-syntax
        const selectedText = cleverapps.UI.generateTTFText(Messages.get("Selected"), cleverapps.styles.FONTS.WINDOW_TEXT);
        selectedText.fitTo(styles.selectedText.width);
        selectedText.setAlignment(selectedCheckBox.width + styles.SelectedBlock.margin.x, selectedCheckBox.y + selectedText.height / 2);
        selectedText.setAnchorPoint(0, 0.5);
        selectedNode.addChild(selectedText);
        // eslint-disable-next-line no-restricted-syntax
        const selectedAmountText = cleverapps.UI.generateTTFText("", cleverapps.styles.FONTS.WINDOW_TEXT);
        selectedAmountText.setAnchorPoint(0.5, 0.5);
        this.selectedAmountText = selectedAmountText;
        selectedNode.addChild(selectedAmountText);
        this.updateSelectedContent();
        selectedAmountText.setAlignment(selectedText.x + selectedText.width / 2, selectedCheckBox.y - selectedAmountText.height / 2);

        selectedNode.setContentSize(selectedCheckBox.width + selectedText.width + styles.SelectedBlock.margin.x, selectedCheckBox.height);
        this.content.addChild(selectedNode);

        cleverapps.UI.applyHover(selectedNode, {
            onMouseOver: function () {
                selectedCheckBox.setScale(1.1);
            },
            onMouseOut: function () {
                selectedCheckBox.setScale(1);
            }
        });

        cleverapps.UI.onClick(selectedNode, () => {
            this.switchSelectAll(selectedCheckBox);
        });

        let innerContainer = new cc.Node();
        innerContainer.setAnchorPoint(0.5, 0.5);

        this.friendContainers = friends.map(function (friendInfo, index) {
            return {
                container: this.generateFriendContent(friendInfo),
                order: index
            };
        }, this);

        levels.friendSorter.update();

        this.friendContainers.sort((a, b) => {
            if (a.container.notActive !== b.container.notActive) {
                return a.container.notActive ? 1 : -1;
            }
            if (levels.friendSorter.canUse(a.container.fullData.id) !== levels.friendSorter.canUse(b.container.fullData.id)) {
                return levels.friendSorter.canUse(a.container.fullData.id) ? -1 : 1;
            }
            return a.order - b.order;
        });

        if (this.friendContainers.length > SelectFriendWindow.MAX_ROWS_AMOUNT * SelectFriendWindow.IN_ROW) {
            this.friendContainers = this.friendContainers.slice(0, SelectFriendWindow.MAX_ROWS_AMOUNT * SelectFriendWindow.IN_ROW);
        }

        for (let i = 0; i < this.friendContainers.length; i++) {
            innerContainer.addChild(this.friendContainers[i].container);
            this.friendContainers[i].container.setAlignment(
                (i % SelectFriendWindow.IN_ROW) * (styles.friendContainer.margin + styles.friendContainer.width) + styles.friendContainer.width / 2,
                innerContainer.height - Math.floor(i / SelectFriendWindow.IN_ROW) * (styles.friendContainer.margin + styles.friendContainer.height) - styles.friendContainer.height / 2
            );
        }

        innerContainer = cleverapps.UI.wrap(innerContainer);
        this.friendsContainer = new cleverapps.UI.ScrollView(innerContainer);

        this.friendsContainer.setContentSize(innerContainer.width + cleverapps.styles.SelectFriendWindow.scroll.margin.mx[0], styles.friendsContainer.height);
        this.friendsContainer.setAnchorPoint(0.5, 0);
        this.friendsContainer.setAlignment(this.content.width / 2, styles.friendsContainer.y);
        this.friendsContainer.scrollToDefault();

        if (!connector.info.isNative) {
            this.switchSelectAll(selectedCheckBox);
        }

        this.content.addChild(this.friendsContainer);
    },

    switchSelectAll: function (container) {
        if (container.selected) {
            container.selected = false;
            container.check.removeFromParent();
            for (let i = this.selectedElements.friends.length - 1; i >= 0; i--) {
                this.checkElementByFriendId(this.selectedElements.friends[i]);
            }
        } else {
            let checked = false;
            for (let j = 0; j < this.friendContainers.length; j++) {
                const friendContainer = this.friendContainers[j].container;
                const data = friendContainer.fullData;
                if (this.selectedElements.friends.length < SelectFriendWindow.MAX_SELECTED && !friendContainer.notActive && !data.checkBox.checked) {
                    this.checkElementByFriendId(data.id, data.checkBox);
                    checked = true;
                }
            }
            if (checked) {
                container.selected = true;
                this.addCheck(container);
            }
        }
    },

    updateSelectedContent: function () {
        this.selectedAmountText.setString(`${this.selectedElements.friends.length}/${SelectFriendWindow.MAX_SELECTED}`);
        if (!this.selectedElements.friends.length) {
            this.button.disable();
        } else {
            this.button.enable();
        }
    },

    generateNoFriendsContent: function () {
        const styles = cleverapps.styles.SelectFriendWindow.noFriends;
        this.content.setContentSize(styles.width, styles.height);

        // eslint-disable-next-line no-restricted-syntax
        const text = cleverapps.UI.generateTTFText(Messages.get(SelectFriendWindow.ByType[this.type].noFriends), cleverapps.styles.FONTS.WINDOW_TEXT);
        text.setAlignment(this.content.width / 2, styles.Text.y);
        text.setDimensions(styles.Text.width, 0);
        text.fitTo(undefined, styles.Text.height);
        text.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        this.content.addChild(text);

        const button = new cleverapps.UI.Button({
            text: Messages.get("SettingsWindow.InviteFriends"),
            width: styles.Button.width,
            height: styles.Button.height,
            onClicked: function () {
                cleverapps.SocialManager.share("invite", "default", this.createListener(this.close.bind(this)));
            }.bind(this)
        });
        button.setAlignment(this.content.width / 2, styles.Button.y);
        this.content.addChild(button);
    },

    onClose: function () {
        if (this.callback && !this.send) {
            this.callback(cleverapps.CODE_CANCELLED);
        }
    }
});

SelectFriendWindow.CreateAndSendRequest = function (name, payload, callback) {
    cleverapps.focusManager.display({
        focus: "SelectFriendWindow",
        stack: true,
        action: function (f) {
            const cb = (code, result) => {
                callback && callback(code, result);
                f();
            };

            const sendRequest = function (ids) {
                cleverapps.requests.send(ids, name, payload, cb);
            };

            if (connector.platform.oneOf(connector.OK, connector.INSTANT)) {
                sendRequest();
                return;
            }

            new SelectFriendWindow(name, sendRequest, cb);
        }
    });
};

SelectFriendWindow.ByType = {
    askLiveRequest: {
        title: "SelectFriendWindow.askLives.title",
        button: "Ask",
        noFriends: "SelectFriendWindow.askLives.noFriendsText",
        dataLoaderType: function () {
            return DataLoader.TYPES.ASKED_LIVES;
        }
    },

    askStarRequest: {
        title: "SelectFriendWindow.askStars.title",
        button: "Ask",
        noFriends: "SelectFriendWindow.askStars.noFriendsText",
        dataLoaderType: function () {
            return DataLoader.TYPES.ASKED_STARS;
        }
    },

    sendGift: {
        title: "SelectFriendWindow.sendGift.title",
        button: "Send",
        noFriends: "SelectFriendWindow.sendGift.noFriendsText",
        dataLoaderType: function () {
            return DataLoader.TYPES.SEND_GIFT;
        }
    }
};

SelectFriendWindow.PROCESS_PERIOD = "1 day";
SelectFriendWindow.MAX_SELECTED = 10;
SelectFriendWindow.MAX_ROWS_AMOUNT = 10;
SelectFriendWindow.IN_ROW = 3;

cleverapps.styles.SelectFriendWindow = {
    Avatar: {
        x: 140,
        y: 20,
        height: 130
    },

    scroll: {
        margin: {
            mx: [30]
        }
    },

    withFriends: {
        width: 670,
        height: 750,

        selectedText: {
            width: 250
        },

        friendsContainer: {
            height: 580,
            y: 175
        },

        friendContainer: {
            height: 180,
            width: 210,
            margin: 20,

            Name: {
                width: 200,
                height: 40,
                y: 24
            },

            checkBox: {
                x: 42,
                timer: {
                    y: 24,
                    height: 20
                }
            }
        },

        Button: {
            width: 300,
            height: 120,
            y: 75,
            x: 190,
            margin: 10
        },

        SelectedBlock: {
            y: 75,
            x: 0,
            margin: {
                x: 20
            }
        }
    },

    noFriends: {
        width: 550,
        height: 500,

        Text: {
            y: 300,
            width: 550,
            height: 250
        },

        Button: {
            width: 450,
            height: 120,
            y: 60
        }
    }
};